module.exports = __webpack_public_path__ + "img/bg2@2x.94cd1b92.jpg";